import PaymentStatusIconContainer from './PaymentStatusIconContainer';

export default PaymentStatusIconContainer;
